import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <path
      fill="currentColor"
      stroke="null"
      d="M30.486 27.503c0-.396.135-.78.381-1.089a1.73 1.73 0 0 1 2.439-.27l15.825 12.73a1.745 1.745 0 0 1 0 2.718l-15.825 12.73a1.73 1.73 0 0 1-1.085.382c-.958 0-1.735-.78-1.735-1.74V27.502z"
    />
  </svg>
);

const IconPlay = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconPlay;
